/*!
 * Copyright (C) 2024, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *	2024-08-14 (jhoward)
 *		- Copy visual-menu.store.ts to textual-menu.store.ts and reduce to needed features.
 *
 *	2024-08-26 (jhoward)
 *		- Add selectedMenuItemIds to state in textual-menu.store.ts.
 *		- Add isFavoriteHintShown to state in textual-menu.store.ts.
 *		- Add toggleMenuItemSelected mutation in textual-menu.store.ts.
 *		- Add setSelectedMenuItemIds mutation in textual-menu.store.ts.
 *
 *  2025-02-12 (jhoward)
 *      - Add deviceMacAddress, deviceMacAddressMessage, networkErrorMessage, isAdminView properties to state in visual-menu.store.ts.
 *      - Add setIsAdminView, setNetworkErrorMessage mutations in textual-menu.store.ts.
 */

//@ts-ignore
import Vue from 'vue/dist/vue.esm'
import Vuex from "vuex";
import {TextualMenuState} from "../components/menu/defs";
import {getDateAsUTC} from "../helpers/menu-sections";

Vue.use(Vuex);

export default new Vuex.Store<TextualMenuState>({
  state: {
    currentDate: new Date(),
    currentDateTimeUtc: getDateAsUTC(new Date()).getTime(),
    currentDayOfWeek: (new Date()).getDay(),
    currentTimeOfDay: (new Date()).getHours() * 100 + (new Date()).getMinutes(),
    dateTimer: -1,
    dateTimeout: 60 * 1000, //1 minute

    selectedMenuItemIds: [],
    isFavoriteHintShown: false,

    deviceMacAddress: '',
    deviceMacAddressMessage: '',

    networkErrorMessage: '',

    isAdminView: false,
  },
  mutations: {
    updateDateTime: (state: TextualMenuState, currentDate: Date) => {
      state.currentDate = currentDate;
      state.currentDateTimeUtc = getDateAsUTC(currentDate).getTime();
      state.currentDayOfWeek = currentDate.getDay();
      state.currentTimeOfDay = currentDate.getHours() * 100 + currentDate.getMinutes();
    },
    updateDateTimer: (state: TextualMenuState, timer: number) => {
      state.dateTimer = timer;
    },
    toggleMenuItemSelected: (state: TextualMenuState, data: number[]) => {
      if (-1 === state.selectedMenuItemIds.indexOf(data[0] || 0)) {
        state.selectedMenuItemIds.push(data[0] || 0);
        if (!state.isFavoriteHintShown) {
          state.isFavoriteHintShown = true;
          window.pepNotify.show(
            10000,
            'Click the cart icon in the top right corner to view your saved items.',
            null,
            'VIEW NOW',
            null,
            () => {
              const cartButtonNode = document.querySelector('.item_button--container-cart');
              if (cartButtonNode) {
                cartButtonNode.dispatchEvent(new Event('click'));
              }
            }
          );
        }
      } else {
        state.selectedMenuItemIds = state.selectedMenuItemIds.filter(itemId => {
          return itemId !== data[0] || 0;
        });
      }

      window.pepHelperFunctions.setCachedData('textual_menu--selectedMenuItems-' + (data[1] || 0), state.selectedMenuItemIds, false);
    },
    setSelectedMenuItemIds: (state: TextualMenuState, menuItemIds: number[]) => {
      state.selectedMenuItemIds = menuItemIds;
    },
    setIsAdminView(state: TextualMenuState, isAdminView: boolean) {
      state.isAdminView = isAdminView;
    },
    setNetworkErrorMessage(state: TextualMenuState, message: string) {
      state.networkErrorMessage = message;
    },
  }
});